// extracted by css-extract-rspack-plugin
export default {"hoverPopover":"eVPwymyN8Z89kTod"};